import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { deleteInsight } from 'action/insight'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'

const generateModalText = (title) => ({
  decide: {
    content: 'This action cannot be undone',
    title: `Are you sure you want to delete ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully deleted`
    },
    title: {
      error: `There has been an issue deleting ${title}`,
      success: 'Insight deleted'
    }
  }
})

const DeleteInsight = ({ deleteInsight, insight: { uuid, title }, pagination }) => {
  const handleSubmit = () => deleteInsight(uuid)

  const { decide, outcome } = generateModalText(title)

  return (
    <a onClick={() => confirmModal(handleSubmit, decide, outcome)}>Delete Insight</a>
  )
}

DeleteInsight.propTypes = {
  deleteInsight: PropTypes.func,
  insight: PropTypes.object,
  pagination: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  deleteInsight: bindActionCreators(deleteInsight, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.insight.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteInsight)
